// extracted by mini-css-extract-plugin
module.exports = {"slider":"FTSlider_slider__zen0A","vertical":"FTSlider_vertical__ghJ78","slider_value":"FTSlider_slider_value__2_Wt0"};